import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { IrmLabel } from 'src/models/irmLabel.model';

@Injectable({
  providedIn: 'root',
})
export class IrmReportService {
  baseUrl = environment.apiUrl + 'RecordsIRM/';
  baseUrl2 = environment.apiUrl + 'Report/';

  constructor(
    private http: HttpClient,
    private router: Router,
    private _location: Location
  ) {}

  getAllIrmReports(
    page: number,
    pageSize: number,
    filters
  ): Observable<HttpResponse<IrmReportService[]>> {
    return this.http.get<IrmReportService[]>(
      this.baseUrl + `dataProtect?pg=${page}&pageSize=${pageSize}`,
      { observe: 'response', params: filters }
    );
  }

  getActions(): Observable<HttpResponse<string[]>> {
    return this.http.get<string[]>(this.baseUrl + `actions`, {
      observe: 'response',
    });
  }

  getLabels(): Observable<HttpResponse<IrmLabel[]>> {
    return this.http.get<IrmLabel[]>(this.baseUrl + `labels`, {
      observe: 'response',
    });
  }

  generateGeneralIrmReport(filters, language): Observable<HttpResponse<any>> {
    return this.http.get<any>(
      this.baseUrl2 + `data-protect?culture=${language}`,
      { observe: 'response', params: filters }
    );
  }

  generateEvoIrmReport(filters, language): Observable<HttpResponse<any>> {
    return this.http.get<any>(
      this.baseUrl2 + `data-protect-evo?culture=${language}`,
      { observe: 'response', params: filters }
    );
  }
}
